import { createFileRoute, redirect } from "@tanstack/react-router";
import { appendSearch } from "~/components/lock/lockServiceRoutes";

export const Route = createFileRoute("/$hubMetaName/lock/select")({
	loader: (ctx) => {
		throw redirect({ href: appendSearch(`/${ctx.params.hubMetaName}/swap/select`, ctx.location.searchStr), replace: true });
	},
});
